module.exports = __webpack_public_path__ + "static/img/manual-14.e04b859.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-14.png
// module id = F9yK
// module chunks = 4